import React from 'react';
import PropTypes from 'prop-types';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LessonGrid from '@anu/components/LessonGrid';
import { highlightText } from '@anu/utilities/searchHighlighter';

const StyledBox = withStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(8),
    },
  },
}))(Box);

const QuizScale = ({
  question,
  scale,
  value,
  onChange,
  defaultValue,
}) => {
  return (
    <StyledBox>
      <LessonGrid>
        <Box mb={5}>
          <Typography component="div" variant="subtitle1">{highlightText(question)}</Typography>
        </Box>

        <Slider
          value={value}
          defaultValue={defaultValue}
          min={scale.from}
          max={scale.to}
          onChange={onChange}
          valueLabelDisplay="on"
        />
      </LessonGrid>
    </StyledBox>
  );
};

QuizScale.propTypes = {
  question: PropTypes.string,
  scale: PropTypes.object,
  value: PropTypes.number,
  defaultValue: PropTypes.number,
  correctValue: PropTypes.number,
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
};

export default QuizScale;
